//REACT
import { useState } from 'react';
//CSS
import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
//COMPONENTS
import Menu from './components/jsx/Menu';
import Animation from './components/jsx/Animation';
//IMAGES
import Bottom from "./images/bottom.jpg"
import Gaurill from "./images/gaurill.png"
import NewTemplate from "./images/newTemplate.png"
import Gmail from "./images/contact/gmail.png";
import Linkedin from "./images/contact/linkedin.png";
import Telegram from "./images/contact/telegram.png";
//ARRAYS
import { Answers } from './utils/Answers';

function AppPortuguese() {
  
  const res = Answers
  const [answer,setAnswer]= useState('faz uma pergunta');
  
  const r1 =(answer) =>{ setAnswer(answer = res[0].r1_po)};
  const r2 =(answer) =>{ setAnswer(answer = res[1].r2_po)};
  const r3 =(answer) =>{ setAnswer(answer = res[2].r3_po)};
  const r4 =(answer) =>{ setAnswer(answer = res[3].r4_po)};
  const r5 =(answer) =>{ setAnswer(answer = res[4].r5_po)};
  const r6 =(answer) =>{ setAnswer(answer = res[5].r6_po)};

  return (
    <div className="global_container" id='home'>
      <header>
      <Menu
        title="o o o"
        link1="#home"
        link2="#projects"
        link3="#contact"
        option1="Home"
        option2="Projetos"
        option3="Contato"
        ></Menu>
        
        <Menu
        title="Idioma"
        link1="/"
        link2="/english"
        link3="/portuguese"
        option1="Espanhol"
        option2="Inglês"
        option3="Português"
        ></Menu>
      </header>
      <div className="container">

        <div className="container_1">

        <div className='container_presentation'>
        <div className="name">Mauro <br /> Calodolce</div>
        <div className="profession">Full Stack Developer</div>
        </div>

        <Animation
        first="#id"
        second=".env"
        third="(e)=>"
        fourth="<img>"
        fifth="<div>"
        ></Animation>
        
        <a href='#aboutMe' className='info' id='aboutMe' ><img className="info_img" src={Bottom} /></a>
    
        </div>
        <div className="container_2">
          <div className="titles">Sobre mim</div>
          <div className="container2_presentation">
            <div className='container2_presentation_syntax'>
            Com 20 anos, sou Técnico em Informática, a caminho de me tornar um Desenvolvedor Full Stack.
            Pessoalmente, prefiro trabalhar no lado Front-End, porém, posso realizar
            bem no lado Back-end. Durante meus primórdios no desenvolvimento web
            fazer várias páginas exclusivamente com HTML e CSS, até meados de 2021
            Entrei no mundo da programação, mais precisamente JavaScript e vários de seus respectivos
            Frameworks. 
            </div>
        <div className='container2_presentation_questions'>

          <div className='container2_presentation_questions_questions'>
            <button id='r1' onClick={r1}>¿Por que você escolheu ser um Desenvolvedor Web?</button>
            <button id='r2' onClick={r2}>Qual é a sua educação?</button>
            <button id='r3' onClick={r3}>Quais tecnologias você conhece?</button>
            <button id='r4' onClick={r4}>¿Cual es tu experiencia?</button>
            <button id='r5' onClick={r5}>Qual é a sua experiência?</button>
            <button id='r6' onClick={r6}>O que você prioriza ao criar um projeto?</button>
          </div>
          <div className='container2_presentation_questions_answers'>{answer}</div> 
        </div>
          </div>
        </div>
        <a href='#projects' className='info' id='projects' ><img className="info_img" src={Bottom} /></a>
        <div className="titles">Projetos</div>

        <div className="container_3">
        <a href='http://gaurillcomics.vercel.app' target="_blank" className="container_3_project">
          <img src={Gaurill} className="container_3_img" />
          <div className="container_3_project_info">
            <div className="container_3_project_info_title">GaurillComics</div>
            <span className="container_3_projects_info_text">
            Desenvolvido no estilo Onepage, o objetivo do site é promover de forma 
            estética o trabalho de um ilustrador artístico, onde os usuários não só poderão 
            visualizar o conteúdo, mas terão a possibilidade de contatá-lo. 
            </span>
          </div>
        </a>
 
        <a href='http://newtemplate.vercel.app' target="_blank" className="container_3_project">
          <img src={NewTemplate} className="container_3_img" />
          <div className="container_3_project_info">
            <div className="container_3_project_info_title">New Template</div>
            <span className="container_3_projects_info_text">
              Um site simples e prático, feito para aqueles usuários que não gostam muito do front-end. 
              NewTemplate oferece aos seus visitantes templates HTML e CSS totalmente gratuitos
              poder elaborar um projeto sem a necessidade de esquematizar ou sair de encrencas.
            </span>
          </div>
        </a>
        </div>
        <a href='#contact' className='info' id='contact' ><img className="info_img" src={Bottom} /></a>
        
        <div className="titles">Contato</div> 
        <div className="container_4">
        <div className='container_4_contact'>
          
          <a href="mailto:maucalodolce20@gmail.com?Subject=Comunicacion" target="_BLANCK" className='container_4_contact_link'><img src= {Gmail} alt="Gmail" className='container_4_contact_img' /> <p className='container_4_contact_text'>Email</p></a>
          <a href="https://ar.linkedin.com/in/mauro-calodolce-208041223" target="_BLANCK" className='container_4_contact_link'><img src={Linkedin} alt="Linkedin" className='container_4_contact_img' /><p className='container_4_contact_text'>Linkedin</p></a>
          <a href="https://t.me/Maurocalo" target="_BLANCK" className='container_4_contact_link'><img src={Telegram} alt="Telegram" className='container_4_contact_img' /><p className='container_4_contact_text'>Telegram</p></a>
        </div>

        <div className="container_4_info">
         <div className='container_4_info_link'> <img src={Gmail} className="container_4_info_img" /> maucalodolce20@gmail.com </div>
         <div className='container_4_info_link'> <img src={Telegram} className="container_4_info_img" /> @MauroCalo </div>
         <div className='container_4_info_link'> <img src={Linkedin} className="container_4_info_img" /> Mauro Calodolce </div>
        </div>
          
        </div>
        
      </div>
      <footer>
      <div className="footer_info">
          Este site foi desenvolvido com React Js.
          bem como as páginas que são exibidas na seção de <b>Projetos</b>. <br />
          ©Copyright 2022 | Mauro Calodolce
        </div>
        <div className="footer_options">
          <a href="#home" className='footer_options_option'>Inicio</a>
          <a href="#aboutMe" className='footer_options_option'>Sobre Mí</a>
          <a href="#projects" className='footer_options_option'>Proyectos</a>
          <a href="#contact" className='footer_options_option'>Contacto</a>
        </div>
      <div className="footer_info">
          Para alterar a tradução do site, você pode selecionar
          a janela <b>Idioma</b> no canto superior direito.
          Todas as traduções do site são de autoria própria.
        </div>
      </footer>      
    </div>

  );
}

export default AppPortuguese;